<script lang="ts">
  import type { Video } from '$lib/types/exerciseTypes';
  import CirclePause from '../../../assets/svgs/circle-pause.svelte';
  import CirclePlayFilled from '../../../assets/svgs/circle-play-filled.svelte';

  export let video: Video;

  let paused;
</script>

<div class="relative">
  <video
    autoplay
    muted
    loop
    playsinline
    bind:paused
    class="aspect-auto object-cover video-border w-full rounded-xxl"
  >
    <source src={video.url} />
    <track kind="captions" />
    <p>{video.title}</p>
  </video>
  <button
    class="absolute right-0 bottom-0 m-3"
    style="-webkit-tap-highlight-color: transparent;"
    on:click={() => {
      paused = !paused;
    }}
  >
    {#if paused}
      <CirclePlayFilled width={24} height={24} />
    {:else}
      <CirclePause width={24} height={24} />
    {/if}
  </button>
</div>

<style>
  /* This is to remove the black border that appears on the bottom side of the video */
  .video-border {
    clip-path: inset(0px 0px 1px);
  }
</style>
